import Layer from "@mozaic-ds/freemarker/js/modules/_layer.js";
class ProductRelationsCdp extends lm.Composant {
  constructor(id) {
    super(id);
    this.variantsSection = document.querySelector(".product-variants");
    if (this.variantsSection) this.initVariants();
    if (lm.sentry) this.initSentry();
  }
  initVariants() {
    this.variantsSection.querySelectorAll(".js-variant-button").forEach(button => {
      const layer = new Layer({
        classContent: `js-variant-layer-${button.dataset.index}`
      });
      button.addEventListener("click", () => layer.open());
    });
  }
  initSentry() {
    lm.sentry.configureScope(scope => {
      scope.setTag("kobi.composant", "productrelationscdp");
    });
  }
}
lm.DOMReady(function () {
  new ProductRelationsCdp("productrelationscdp");
});
export default ProductRelationsCdp;